import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";

const fetchAdvancedSurveys = async ({ page = 1, pageSize = 10, paginate = true, search = "" }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  params.append("paginate", paginate);
  params.append("page", page);
  params.append("page_size", pageSize);
  if (search) params.append("search", search);

  const URL = `${__API_URL__}/api/survey/advanced-surveys/?${params.toString()}`;

  const res = await axios.get(URL, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return res.data;
};

const useGetAdvancedSurveys = ({ page = 1, pageSize = 10, paginate = true, search = "" }) => {
  return useQuery({
    queryKey: ["advanced_surveys", page, pageSize, paginate, search],
    queryFn: () => fetchAdvancedSurveys({ page, pageSize, paginate, search }),
    keepPreviousData: true,
  });
};

export default useGetAdvancedSurveys;
